export default __webpack_public_path__ + "static/media/Users.0229913e.md";